import LetterboxPattern from "../../assets/LetterBoxPattern.svg"
import WhiteLogo from "../../assets/WhiteLogo.svg"
import Button from "../Shared/Button"
import Input from "../Shared/Input"
import { Mail } from "lucide-react"
import { useFormik } from "formik";
import * as Yup from "yup";
import { SendNewsletter } from "../../api/Emails/SendNewsletts";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ButtonTypes } from "../../utils/consts";
import { toast } from "react-toastify";
const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const LetterBox = () => {
  const { mutate, error, isPending } = useMutation({
    mutationFn: SendNewsletter, // Updated to include salesLogin
    onSuccess: () => {
      toast.success("Email sent successfully");
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: (values) => {
      mutate(values);
    },
  });

  return (
    <div className="md:mt-24 mt-16 md:pb-32 pb-24 container">
      <div className="w-full bg-secondary text-white relative overflow-hidden sm:h-[380px] h-[340px] rounded-3xl flex flex-col items-center justify-center">
        <img className="h-full w-full absolute sm:object-fill object-cover" src={LetterboxPattern} alt="" />
        <div className="relative z-50 text-center container">
          <img src={WhiteLogo} className="sm:w-[150px] w-[130px] mx-auto" alt="" />
          <h1 className="font-bold md:text-4xl sm:text-3xl text-xl sm:my-4 my-3"> Subscribe To our Newsletter!</h1>
          <p className="max-w-[680px] mx-auto sm:mb-7 mb-4 md:text-base sm:text-sm text-xs">Stay up to date with our new collections, latest deals and special offers! We
            announce a new collection every week so be sure to stay tuned.</p>
          <form onSubmit={formik.handleSubmit} className="flex md:gap-5 justify-center">
            <div>
            <div className="relative sm:w-auto w-full">
              <Input value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                name="email"
                placeholder="Enter your Email" inputStyles="sm:!pl-10 !pl-7 md:!rounded-lg !text-black sm:!h-12 !h-11 !rounded-l-lg !rounded-r-none focus:border-transparent !border-white" className="md:w-[438px] w-full" />
              <Mail className="absolute text-secondary top-1/2 -translate-y-1/2 left-2 sm:size-6 size-4" size={24} />
            </div>
            <p className="text-white sm:text-base text-xs text-start mt-1">
                {formik.touched.email && formik.errors.email
                  ? formik.errors.email
                  : ""}

              </p>

            </div>
            <Button type={ButtonTypes.SUBMIT}
              disabled={formik.isSubmitting || isPending}
              variant="light" className="md:w-[150px] min-w-[120px] sm:!text-base !text-sm sm:!h-12 !h-11 md:!rounded-lg !rounded-r-lg !rounded-l-none" >Subscribe
              {isPending ? (
                <svg
                  aria-hidden="true"
                  className="w-8 h-8 text-gray-200 ml-3 animate-spin inline dark:text-gray-600 fill-secondary"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              ) : (
                ""
              )}
            </Button>
          </form>
          {error instanceof AxiosError && (
            <span className="text-red-500 font-bold text-lg">
              {error?.response?.data?.message || "An error occurred"}
            </span>
          )}

        </div>
      </div>
    </div>
  )
}

export default LetterBox